export const EXSBPERIODTYPE_SHOW_RESET = 'EXSBPERIODTYPE_SHOW_RESET'
export const EXSBPERIODTYPE_SHOW_SET_ERROR = 'EXSBPERIODTYPE_SHOW_SET_ERROR'
export const EXSBPERIODTYPE_SHOW_SET_RETRIEVED = 'EXSBPERIODTYPE_SHOW_SET_RETRIEVED'
export const EXSBPERIODTYPE_SHOW_TOGGLE_LOADING = 'EXSBPERIODTYPE_SHOW_TOGGLE_LOADING'
